import { Box, Button, GridLegacy, TextField } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import smetaAxios from "../../../SmetaAxios";
import { smetaModals, SmetaModalsIdContext } from "../../Tools/modalManager";
import Tree from "../../Windows/ViewData/Tree/Tree";
import { Prefixes } from "../../Tools/ProjectX";

interface DialogCreateObjProps {
  inputNameObj?: string;
  groups?: { Module: string; ObjType: string | number; ObjRef?: string | number };
  CLSID?: string;
  Module: string | Prefixes;
  ObjType: string | number;
  onEdit?: (data: any) => Promise<void>;
  data?: any;
  record?: unknown;
  name?: unknown;
  RequestID?: unknown;
  CheckState?: string;
  spanText?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DialogCreateObj(props: DialogCreateObjProps) {
  const [groupId, setGroupID] = useState();
  const [nameObj, setNameObj] = useState(props.inputNameObj || "");
  const inputEl = useRef<HTMLInputElement>(null!);
  const smetaModalId = useContext(SmetaModalsIdContext);

  useEffect(() => {
    inputEl.current.focus();
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [nameObj, groupId]);

  function handleKeyDown(ev: KeyboardEvent) {
    const target = ev.target;
    if (target instanceof Node && document.body.contains(target)) {
      if (ev.key === "Enter" && nameObj) onEdit();
    }
  }

  async function onEdit() {
    if (nameObj) {
      const res = (await smetaAxios.get("CreateObject", {
        prefix: props.Module,
        params: { ObjType: props.ObjType, GroupID: groupId || "0", Name: nameObj },
        loadMask: true,
      })) as { ObjRef: string; Text?: string; Result: string };
      if (props.onEdit) {
        const data = { ...(props.data || {}) };
        props.onEdit({
          record: props.record,
          textchanged: "0",
          name: props.name,
          setValue: props.data ? props.data.setValue : undefined,
          setInputValue: props.data ? props.data.setInputValue : undefined,
          ...data,
          proof: false,
          value: res.Text ? res.Text : nameObj,
          tag: res.ObjRef,
          requestId: props.RequestID,
          CheckState: props.CheckState || "0",
        });
      }
      smetaModals.close(smetaModalId);
      return;
    }
  }

  return (
    <>
      <Box style={{ width: "100%", height: "calc(100% - 40px)" }}>
        <GridLegacy item style={{ margin: "8px", width: "calc(100% - 10px)" }}>
          <span style={{ width: "46px" }}>
            {props.spanText === undefined ? "Наименование объекта:" : props.spanText}
          </span>
          <TextField
            inputRef={inputEl}
            size="small"
            id="name-object"
            autoComplete="off"
            variant="outlined"
            value={nameObj}
            fullWidth={true}
            error={nameObj === "" ? true : false}
            helperText={nameObj === "" ? "Не указано наименование объекта" : ""}
            onChange={(ev) => {
              setNameObj(ev.target.value);
            }}
          />
        </GridLegacy>
        {props.groups ? (
          <GridLegacy item style={{ width: "100%", height: nameObj === "" ? "68%" : "73%" }}>
            <Tree
              props={{
                CLSID: props.CLSID,
                multiCheck: false,
                ObjType: props.groups.ObjType,
                Module: props.groups.Module,
                ObjRef: props.groups.ObjRef ? props.groups.ObjRef : "0",
                UsedDate: "0",
                selectID: setGroupID,
              }}
            />
          </GridLegacy>
        ) : null}
      </Box>
      <Box style={{ height: "10px", width: "100%" }}>
        <GridLegacy container direction="row" justifyContent="flex-end" alignItems="center">
          <Button
            size="small"
            variant="outlined"
            style={{ textTransform: "none", marginRight: "10px" }}
            value="1"
            className="button_Modal_Select"
            disabled={nameObj === "" ? true : false}
            onClick={onEdit}
          >
            Выбрать
          </Button>
          <Button
            size="small"
            variant="outlined"
            style={{ textTransform: "none" }}
            value="2"
            className="button_Modal_Close"
            onClick={() => smetaModals.close(smetaModalId)}
          >
            Отмена
          </Button>
        </GridLegacy>
      </Box>
    </>
  );
}
